"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.debug = exports.hasOwnProperty = exports.setProp = exports.getProp = exports.isEntity = void 0;
var model_js_1 = require("@cognitoforms/model.js");
function isEntity(obj) {
    return obj && obj.meta && obj.meta.type && obj.meta.type.jstype && (0, model_js_1.isEntityType)(obj.meta.type.jstype);
}
exports.isEntity = isEntity;
function getProp(obj, prop) {
    return obj[prop];
}
exports.getProp = getProp;
function setProp(target, key, value) {
    target[key] = value;
}
exports.setProp = setProp;
var hasOwnPropertyFn = Object.prototype.hasOwnProperty;
function hasOwnProperty(obj, prop) {
    return hasOwnPropertyFn.call(obj, prop);
}
exports.hasOwnProperty = hasOwnProperty;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function debug(message) {
    // console.log("%c[DEBUG] " + message, "background-color: #efefef; color: #999;");
}
exports.debug = debug;
